import Vue from 'vue'
import Vuex from 'vuex'
import authentication from './modules/authentication'
import order from './modules/order'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        authentication,
        order
    }
})